import { CustomLink } from "../CustomLink/CustomLink";
import { useBreadcrumbs } from "../../../hooks/useBreadcrumbs";
import { HouseIcon } from "../../assets/Icons/HouseIcon";
import { Breadcrumbs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function CustomBreadcrumbs() {
  const { breadcrumbs } = useBreadcrumbs();
  const { t } = useTranslation();
  return (
    <Breadcrumbs aria-label="breadcrumb" separator={">"}>
      <CustomLink icon={<HouseIcon />} link="/" label="" />
      {breadcrumbs.map((breadcrumb, index) => (
        <span
          key={breadcrumb.to}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {breadcrumb.isLast ? (
            <span style={{ color: "#333333" }}>
              {t(
                `layout.header.${breadcrumb.name?.toLocaleLowerCase()}`,
                breadcrumb.name
              )}
            </span>
          ) : (
            <Typography style={{ color: "#333333", textDecoration: "none" }}>
              {t(
                `layout.header.${breadcrumb.name?.toLocaleLowerCase()}`,
                breadcrumb.name
              )}
            </Typography>
          )}
        </span>
      ))}
    </Breadcrumbs>
  );
}
